import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export enum PortalNewPostCategory {
  FEATURE = "FEATURE",
  IMPROVEMENT = "IMPROVEMENT",
  BUGFIX = "BUGFIX",
  PRODUCT = "PRODUCT",
  RELEASE = "RELEASE"
}

export const PortalNewsPostObjClass = Scrivito.provideObjClass(
  "PortalNewsPost",
  {
    attributes: {
      ...defaultPageAttributes,
      text: ["widgetlist", { only: ["TextWidget"] }],
      category: ["enum", { values: Object.values(PortalNewPostCategory) }],
      portalVersion: "string",
      date: "datetime",
      media: [
        "widgetlist",
        {
          only: [
            "ImageWidget",
            "VideoWidget",
            "YoutubeVideoWidget",
            "VimeoVideoWidget"
          ]
        }
      ]
    }
  }
)
export type PortalNewsPostObj = InstanceType<typeof PortalNewsPostObjClass>
